import React, { useEffect, useState } from 'react';
import DetailItem from './DetailItem';
import '../Entreprise/Detailsmission/Detailsmission.css';
import ActionButtons from './ActionButtons';
import ChipInput from './ChipInput';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  InputAdornment,
  DialogActions,
} from '@mui/material';
import {
  languageOptions,
  languageLevelOptions,
  contractTypeOptions,
  secteurOptions,
} from './constants/options';
import Avatar from '@mui/material/Avatar';
import { fetchSkillsFromLightcast } from '../../services/lightcastApi';
import { Grid } from '@mui/system';

const ProfilRecherche = ({
  editedMission,
  editable,
  onChange,
  onSave,
  onToggleEdit,
  showActionButtons = false,
  entrepriseLogo,
  isRecruteurView = false,
  onToggleStatus
}) => {
  const [skillSuggestions, setSkillSuggestions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedContract, setSelectedContract] = useState('');
  const [tarifMin, setTarifMin] = useState('');
  const [tarifMax, setTarifMax] = useState('');
  const [devise, setDevise] = useState('EUR');
  const [errorContract, setErrorContract] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);

  const handleSkillInputChange = async (input) => {
    if (input?.length >= 2) {
      try {
        const suggestions = await fetchSkillsFromLightcast(input);
        setSkillSuggestions(suggestions.map((s) => s.label || s.nom || s));
      } catch (error) {
        console.error("Erreur lors du chargement des compétences :", error);
      }
    }
  };

  const handleOpenAdd = () => {
    setSelectedContract('');
    setTarifMin('');
    setTarifMax('');
    setDevise('EUR');
    setEditingIndex(null);
    setErrorContract('');
    setOpenDialog(true);
  };
  
  const handleOpenEdit = (index) => {
    const contrat = editedMission.contrats[index];
    setSelectedContract(contrat.type);
    setTarifMin(contrat.tarifMin);
    setTarifMax(contrat.tarifMax);
    setDevise(contrat.devise);
    setEditingIndex(index);
    setErrorContract('');
    setOpenDialog(true);
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setErrorContract('');
  };
  
  const handleSaveContract = () => {
    if (!selectedContract || !tarifMax) {
      setErrorContract('Veuillez remplir tous les champs.');
      return;
    }
    if (Number(tarifMin) > Number(tarifMax)) {
      setErrorContract('Le minimum doit être inférieur ou égal au maximum.');
      return;
    }
    const updated = [...(editedMission.contrats || [])];
    const duplicateIndex = updated.findIndex(c => c.type === selectedContract);
    if (editingIndex !== null) {
      updated[editingIndex] = { type: selectedContract, tarifMin, tarifMax, devise };
    } else if (duplicateIndex !== -1) {
      updated[duplicateIndex] = { type: selectedContract, tarifMin, tarifMax, devise };
    } else {
      updated.push({ type: selectedContract, tarifMin, tarifMax, devise });
    }
  
    onChange('contrats', updated);
    handleCloseDialog();
  };
  
  const handleDeleteContract = (index) => {
    const updated = [...(editedMission.contrats || [])];
    updated.splice(index, 1);
    onChange('contrats', updated);
  };
  
  const currencySelector = (
    <InputAdornment position="end">
      <FormControl variant="standard" sx={{ minWidth: 60 }}>
        <Select
          value={devise}
          onChange={(e) => setDevise(e.target.value)}
          disableUnderline
        >
          <MenuItem value="EUR">EUR</MenuItem>
          <MenuItem value="MAD">MAD</MenuItem>
          <MenuItem value="TND">TND</MenuItem>
          <MenuItem value="EGP">EGP</MenuItem>
        </Select>
      </FormControl>
    </InputAdornment>
  );

  return (
    <article className="missionContainer">
      <header className="missionHeader updated-layout">
        <div className="missionHeader-right">
        {!isRecruteurView && (
            <>
              <Button
                variant="outlined"
                className={`status-btn ${editedMission.status === 'active' ? 'green' : 'red'}`}
                onClick={onToggleStatus}
              >
                   {editedMission.status === 'active' 
                  ? 'PUBLIÉE' 
                  : editedMission.status?.toUpperCase()}
              </Button>

            </>
          )}
        {showActionButtons && (
          <div className="action-buttons-container">
            <ActionButtons
              isEditing={editable}
              onEdit={onToggleEdit}
              onSave={onSave}
              onCancel={onToggleEdit}
              showDelete={false}
              showDownload={false}
              showView={false}
            />
          </div>
        )}
        </div>
      </header>

      <div className="profilGrid">
        <div className="profilColumn">
          {editable ? (
            <>
              <ChipInput
                label="Compétences clés"
                values={editedMission.competences || []}
                onChange={(v) => onChange('competences', v)}
                suggestions={skillSuggestions}
                onInputChange={handleSkillInputChange}
              />

              <TextField
                label="Formation / Diplômes"
                value={editedMission.formation}
                onChange={(e) => onChange('formation', e.target.value)}
                fullWidth
                margin="normal"
              />

              <div className="langues-section">
                {(editedMission.langues || []).map((entry, index) => (
                  <div className="langue-row" key={index}>
                    <FormControl className="step-two-half">
                      <InputLabel>Langue</InputLabel>
                      <Select
                        value={entry.langue || ''}
                        onChange={(e) => {
                          const updated = [...editedMission.langues];
                          updated[index].langue = e.target.value;
                          onChange('langues', updated);
                        }}
                        label="langue"
                      >
                        {languageOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl className="step-two-half">
                      <InputLabel>Niveau</InputLabel>
                      <Select
                        value={entry.niveau || ''}
                        onChange={(e) => {
                          const updated = [...editedMission.langues];
                          updated[index].niveau = e.target.value;
                          onChange('langues', updated);
                        }}
                        label="Niveau"
                      >
                        {languageLevelOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Button
                      variant="text"
                      color="error"
                      onClick={() => {
                        const updated = [...editedMission.langues];
                        updated.splice(index, 1);
                        onChange('langues', updated);
                      }}
                      className="delete-langue-btn"
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                ))}

                <Button
                  variant="outlined"
                  onClick={() =>
                    onChange('langues', [
                      ...(editedMission.langues || []),
                      { langue: '', niveau: '' },
                    ])
                  }
                  className="ajouter-langue-btn"
                >
                  + Ajouter une langue
                </Button>
              </div>
            </>
          ) : (
            <>
              {editedMission.competences?.length > 0 && (
                <DetailItem
                  label="Compétences clés"
                  value={editedMission.competences.join(', ')}
                />
              )}
              {editedMission.formation && (
                <DetailItem
                  label="Formation / Diplômes"
                  value={editedMission.formation}
                />
              )}
              {editedMission.langues?.length > 0 && (
                <DetailItem
                label="Langues requises"
                value={editedMission.langues
                  .map((l) => `${l.langue} (${l.niveau})`)
                  .join('\n')}
               />              
              )}
              {editedMission.disponibilite && (
                <DetailItem
                  label="Disponibilité idéale"
                  value={new Date(editedMission.disponibilite).toLocaleDateString('fr-FR')}
                />
              )}
            </>
          )}
        </div>

        <div className="profilColumn">
          {editable ? (
            <>
              <TextField
                label="Expérience souhaitée"
                value={editedMission.experience}
                onChange={(e) => onChange('experience', e.target.value)}
                fullWidth
              />

              <FormControl fullWidth margin="normal">
                <InputLabel>Secteur d'activité</InputLabel>
                <Select
                  value={editedMission.secteur || ''}
                  onChange={(e) => onChange('secteur', e.target.value)}
                  label="Secteur d'activité"
                >
                  <MenuItem value="">
                    <em>Sélectionnez un secteur</em>
                  </MenuItem>
                  {secteurOptions.map((option) => (
                    <MenuItem key={option.code} value={option.libelle}>
                      {option.libelle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {editedMission.contrats?.length > 0 && (
                <div className="contract-list">
                  {editedMission.contrats.map((c, index) => (
                    <div key={index} className="contract-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                      <span>
                        {c.type} : {c.tarifMin || '—'} {c.devise || ''} - {c.tarifMax || '—'} {c.devise || ''}
                      </span>
                      <div>
                        <Button onClick={() => handleOpenEdit(index)} color="primary">
                          ✏️
                        </Button>
                        <Button onClick={() => handleDeleteContract(index)} color="error">
                          <DeleteIcon />
                        </Button>

                      </div>
                    </div>
                  ))}
                </div>
              )}

              <Button variant="outlined" color="primary" onClick={handleOpenAdd} className="ajouter-langue-btn">
                + Ajouter un contrat
              </Button>
            </>
          ) : (
            <>
            {editedMission.secteur && (
                <DetailItem
                  label="Secteur d'activité"
                  value={
                    secteurOptions.find(opt => opt.code === editedMission.secteur)?.libelle ||
                    editedMission.secteur
                  }
                />
            )}
            {editedMission.experience && (
            <DetailItem
              label="Expérience souhaitée"
              value={editedMission.experience}
            />
              )}
            {editedMission.contrats?.length > 0 && (
              <DetailItem
                label="Type(s) de contrat"
                value={editedMission.contrats
                  .map(
                    (c) =>
                      `${c.type} : ${c.tarifMin || '—'} ${c.devise || ''} - ${c.tarifMax || '—'} ${c.devise || ''}`
                  )
                  .join('\n ')}
              />
            )}
          </>
          )}
        </div>

        <div className="profilColumn">
        {editable ? (
            <>
              <TextField
                label="Informations complémentaires"
                value={editedMission.infoComplementaires || ''}
                onChange={e => onChange('infoComplementaires', e.target.value)}
                fullWidth
                margin="normal"
                multiline
                minRows={3}
              />
            </>
          ) : (
            <>
              {editedMission.infoComplementaires && (
                <DetailItem
                  label="Informations complémentaires"
                  value={editedMission.infoComplementaires}
                />
              )}
            </>
          )}
      </div>
    </div>


      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>
          {editingIndex !== null ? 'Modifier le contrat' : 'Ajouter un contrat'}
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal"  >
            <InputLabel>Type</InputLabel>
            <Select
              value={selectedContract}
              onChange={(e) => setSelectedContract(e.target.value)}
              disabled={editingIndex !== null} 
              label="Priorité"
            >
              {contractTypeOptions.map((option) => (
                <MenuItem
                  key={option.label}
                  value={option.label}
                  disabled={
                    editingIndex === null &&
                    (editedMission.contrats || []).some((c) => c.type === option.label)
                  }
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box display="flex" gap={2} mt={2}>
            <TextField
              fullWidth
              label={selectedContract === 'CDI' ? 'Salaire minimum' : 'TJM minimum'}
              value={tarifMin || ''}
              onChange={(e) => setTarifMin(e.target.value)}
              type="number"
              InputProps={{
                endAdornment: currencySelector,
              }}
            />
            <TextField
              fullWidth
              label={selectedContract === 'CDI' ? 'Salaire maximum' : 'TJM maximum'}
              value={tarifMax}
              onChange={(e) => setTarifMax(e.target.value)}
              type="number"
              InputProps={{
                endAdornment: currencySelector,
              }}
            />
          </Box>


          {errorContract && <p className="error-message">{errorContract}</p>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Annuler</Button>
          <Button onClick={handleSaveContract} variant="contained">
            {editingIndex !== null ? 'Enregistrer' : 'Ajouter'}
          </Button>
        </DialogActions>
      </Dialog>
    </article>
  );
};

export default ProfilRecherche;
